module.exports = __webpack_public_path__ + "assets/img/05-m.982d9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/05-m.jpg
// module id = psHA
// module chunks = 0